<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">EXPERIENCE MANAGER</div>
      <div class="d-flex m__t--42">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'single'}"
          class="tab-experience-manager m__r--35"
          @click="selectTab('single')">
          SINGLE FORM
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'multiple'}"
          class="tab-experience-manager"
          @click="selectTab('multiple')">
          MULTIPLE FORM
        </div>
      </div>
    </div>

    <div class="studio-page-content">
      <v-server-table
        v-show="load_first && tabSelected === 'single'"
        ref="formUiTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="openModalCreateNew">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="$refs.appImportModal.show(); dropboxImportShow = true">
              <i class="fa fa-cloud-upload fa-lg"/> Import
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <j-select
                v-model="select_type"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInputSingle"
                v-model="filter_data"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="checkbox"
          slot-scope="props"
          style="width: 5px"
          class="jTableReport">
          <b-form-group>
            <b-form-checkbox-group v-model="selected_rows">
              <b-form-checkbox :value="props.row"/>
            </b-form-checkbox-group>
          </b-form-group>
        </div>

        <div
          slot="id"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ props.row.name }}
        </div>

        <div
          slot="type"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ typeUi(props.row) }}
        </div>

        <div
          slot="source"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ sourceUi(props.row) }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="openDetail(props.row.id)">
          {{ convertDateTime(props.row.updated_at) }}
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first && tabSelected === 'single'"/>

      <v-server-table
        v-show="load_first_multi && tabSelected === 'multiple'"
        ref="multiFormUiTableComponent"
        :columns="columns_multi"
        :options="table_options_multi"
        class="jTable"
        @loading="loadingMulti"
        @loaded="loadedMulti">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="openModalCreateNew">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="$refs.appImportModal.show(); dropboxImportShow = true">
              <i class="fa fa-cloud-upload fa-lg"/> Import
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filterMulti(filter_data_multi)">
              <j-select
                v-model="select_type_multi"
                :options="options_search_multi"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInputMultiple"
                v-model="filter_data_multi"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="checkbox"
          slot-scope="props"
          style="width: 5px"
          class="jTableReport">
          <b-form-group>
            <b-form-checkbox-group v-model="selected_rows">
              <b-form-checkbox :value="props.row"/>
            </b-form-checkbox-group>
          </b-form-group>
        </div>

        <div
          slot="id"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ props.row.name }}
        </div>

        <div
          slot="type"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ typeUi(props.row) }}
        </div>

        <div
          slot="form_data_name"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ props.row.form_data_name }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="openDetailMulti(props.row.id)">
          {{ convertDateTime(props.row.updated_at) }}
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first_multi && tabSelected === 'multiple'"/>
    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="targetSearch"
      triggers="click"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="modalForm"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <j-form-ui-create
        v-if="isOpen"
        mode="single"
        @close-modal="closeModalCreate"/>
    </b-modal>

    <b-popover
      ref="searchFormMultiModal"
      :show.sync="popoverSearchMultiShow"
      container="form-search-popover"
      target="targetSearchMulti"
      triggers="click"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filterMulti(filter_data_multi)">
        <j-select
          v-model="select_type_multi"
          :disabled="false"
          :options="options_search_multi"
          class="m__r--5"/>
        <j-input
          v-model="filter_data_multi"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filterMulti(filter_data_multi)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="modalFormMulti"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <j-multiple-form-ui-create
        v-if="isOpenMulti"
        @close-modal="closeModalCreateMulti"/>
    </b-modal>

    <b-modal
      ref="appTypeFormDataModal"
      class="mod-form modal-type-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE {{ tabSelected === 'multiple' ? 'MULTIPLE' : 'SINGLE' }} EXPERIENCE MANAGER</div>
      <div class="container-type-list-options">
        <div
          :class="typeMode === 'blank' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('blank')">
          <img
            v-if="typeMode === 'blank'"
            src="@/assets/icon/blank-blue.png">
          <img
            v-else
            src="@/assets/icon/blank.png">
          <span class="text-option">Create New Blank</span>
        </div>
        <div
          :class="typeMode === 'code' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('code')">
          <img
            v-if="typeMode === 'code'"
            src="@/assets/icon/code-blue.png">
          <img
            v-else
            src="@/assets/icon/code.png">
          <span class="text-option">Execute Code</span>
        </div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeTypeForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="nextStep">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-code-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE {{ tabSelected === 'multiple' ? 'MULTIPLE' : 'SINGLE' }} EXPERIENCE MANAGER</div>
      <label> JSON </label>
      <j-monaco-editor
        v-if="showEditor"
        ref="jsonEditor"
        :value="jsonData"
        language="json"
      />
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createCodeData">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <div
      :class="{'show-container-floating-data-manager' : showProperties,
               'hide-container-floating-data-manager' : !showProperties,
               'container-floating-data-manager-long' : !is_sidebar_minimized}"
      class="container-floating-data-manager">
      <div class="count-data-selected">{{ selected_rows.length }}</div>
      <div class="label-data-selected">{{ tabSelected === 'single' ? 'Single' : 'Multiple' }} Experience Manager <br> Selected</div>
      <div
        class="btn-export-data"
        @click="exportData">
        <img :src="require('@/assets/icon/export-data-white.svg')"> Export
      </div>
      <div
        class="close-data-selected"
        @click="selected_rows = []">X</div>
    </div>

    <b-modal
      ref="appImportModal"
      class="mod-form modal-add-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">IMPORT</div>
      <div
        v-if="dropboxImportShow"
        class="dropbox-oos">
        <input
          type="file"
          multiple
          class="input-file"
          @change="handleFileUpload($event.target.files)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your file here, or <span>browse</span></div>
        <div class="label-support-dropbox">Support : ZIP</div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeImportForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import jwtDecode from 'jwt-decode';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiFormUi from '@/services/jApiFormUi';
import axios from 'axios';
import Vue from 'vue';

import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

import jFormUiCreate from './jFormUiCreate';
import jMultipleFormUiCreate from './jMultipleFormUiCreate';

export default {
  components: {
    jLoadingTable,
    jFormUiCreate,
    jMultipleFormUiCreate,
    jMonacoEditor,
  },
  data() {
    return {
      jsonData: '',
      typeMode: '',
      darkMode: false,
      tabSelected: 'single',
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      selected_rows: [],
      dropboxImportShow: false,
      showEditor: false,

      // Single Form UI
      popoverSearchShow: false,
      isOpen: false,
      load_first: false,
      filter_data: '',
      select_type: 'name',
      data_table: [],
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['checkbox', 'id', 'name', 'type', 'source', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          checkbox(h) {
            const objThis = this;
            return this.checkbox(h, objThis);
          },
          id: 'ID',
          name: 'NAME',
          type: 'TYPE',
          source: 'SOURCE',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: ['id', 'name', 'type', 'created_at', 'updated_at'],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],

        requestAdapter(data) {
          let sortData = {};
          switch (data.orderBy) {
            case 'name':
              sortData = { name: data.ascending ? 1 : -1 };
              break;
            case 'id':
              sortData = { id: data.ascending ? 1 : -1 };
              break;
            case 'type':
              sortData = { type: data.ascending ? 1 : -1 };
              break;
            case 'created_at':
              sortData = { created_at: data.ascending ? 1 : -1 };
              break;
            case 'updated_at':
              sortData = { updated_at: data.ascending ? 1 : -1 };
              break;
            default:
              sortData = { updated_at: -1 };
          }
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              sort: sortData,
            },
          };
        },
        requestFunction(data) {
          const list = jApiFormUi.listForm(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      // Multiple Form UI
      popoverSearchMultiShow: false,
      isOpenMulti: false,
      load_first_multi: false,
      filter_data_multi: '',
      select_type_multi: 'name',
      data_table_multi: [],
      options_search_multi: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns_multi: ['checkbox', 'id', 'name', 'type', 'form_data_name', 'created_at', 'updated_at'],
      table_options_multi: {
        headings: {
          checkbox(h) {
            const objThis = this;
            return this.checkbox(h, objThis);
          },
          id: 'ID',
          name: 'NAME',
          type: 'TYPE',
          form_data_name: 'SOURCE',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: ['id', 'name', 'type', 'form_data_name', 'created_at', 'updated_at'],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],

        requestAdapter(data) {
          let sortData = {};
          switch (data.orderBy) {
            case 'name':
              sortData = { name: data.ascending ? 1 : -1 };
              break;
            case 'id':
              sortData = { id: data.ascending ? 1 : -1 };
              break;
            case 'type':
              sortData = { type: data.ascending ? 1 : -1 };
              break;
            case 'form_data_name':
              sortData = { form_data_name: data.ascending ? 1 : -1 };
              break;
            case 'created_at':
              sortData = { created_at: data.ascending ? 1 : -1 };
              break;
            case 'updated_at':
              sortData = { updated_at: data.ascending ? 1 : -1 };
              break;
            default:
              sortData = { updated_at: -1 };
          }
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              sort: sortData,
            },
          };
        },
        requestFunction(data) {
          const list = jApiFormUi.listMultiForm(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    showProperties() {
      return this.selected_rows.length > 0;
    },
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.formUiTableComponent.setFilter('');
      }
    },

    filter_data_multi(val) {
      if (val === '') {
        this.$refs.multiFormUiTableComponent.setFilter('');
      }
    },

    load_first(val) {
      if (val) {
        setTimeout(() => {
          if (this.tabSelected === 'single') {
            this.$refs.filterInputSingle.focus();
          } else {
            this.$refs.filterInputMultiple.focus();
          }
        }, 200);
      }
    },

    tabSelected(val) {
      setTimeout(() => {
        if (val === 'single') {
          this.$refs.filterInputSingle.focus();
        } else {
          this.$refs.filterInputMultiple.focus();
        }
      }, 200);
    },
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreFormUi', ['createForm', 'createMultiForm']),

    checkbox(h, objThis) {
      const thisParams = objThis;
      const dataTable = objThis.tabSelected === 'single' ? thisParams.data_table : thisParams.data_table_multi;
      function checkedAll() {
        thisParams.selected_rows = dataTable;
      }
      function unCheckedAll() {
        thisParams.selected_rows = [];
      }
      if (thisParams.selected_rows.length === dataTable.length) {
        return (
          <i
            id= 'select-all-unchecked'
            class= 'fa fa-check-square i--center-block pointer--cursor'
            style= {{ display: 'block', fontSize: '20px' }}
            onClick= { unCheckedAll }>
          </i>
        );
      }
      return (
        <i
          id= 'select-all-unchecked'
          class= 'fa fa-square-o i--center-block pointer--cursor'
          style= {{ display: 'block', fontSize: '20px' }}
          onClick= { checkedAll }>
        </i>
      );
    },

    exportData() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
      const token = Vue.ls.get('Token');
      const gateUrl = localStorage.getItem('gateUrl');
      const formUrl = this.tabSelected === 'single' ? 'form' : 'multiple-form-ui';
      const url = `${gateUrl}nocode/${formUrl}/export-v2`;
      const params = {
        id: this.selected_rows.map(val => val.id),
      };

      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }).then((res) => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        const a = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(res.data);
        const formName = this.tabSelected === 'single' ? 'single' : 'multiple';
        const fileName = `${formName}-experience-manager.zip`;

        a.href = urlBlob;
        a.download = fileName;
        a.click();
      });
    },

    handleFileUpload(file) {
      console.log(file);
      if (file[0].type.includes('zip')) {
        this.$swal({
          title: 'IMPORT',
          text: `Are you sure to import file ${file[0].name} ?`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
            const token = Vue.ls.get('Token');
            const formData = new FormData();
            const gateUrl = localStorage.getItem('gateUrl');
            const formUrl = this.tabSelected === 'single' ? 'form' : 'multiple-form-ui';
            const url = `${gateUrl}nocode/${formUrl}/import-v2?token=${token}`;

            formData.append('file', file[0]);

            axios.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
            ).then(() => {
              const table = this.tabSelected === 'single' ? 'formUiTableComponent' : 'multiFormUiTableComponent';
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Success Import Data');
              this.$refs[table].refresh();
              this.closeImportForm();
            }).catch(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Error Import Data');
            });
          } else {
            this.dropboxImportShow = false;
            setTimeout(() => {
              this.dropboxImportShow = true;
            }, 100);
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'File not support');
      }
    },

    closeImportForm() {
      this.$refs.appImportModal.hide();
      this.dropboxImportShow = false;
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    typeUi(data) {
      let type = '';
      switch (data.type) {
        case 'form':
          type = 'Data Manager';
          break;
        case 'external_url':
          type = 'External API';
          break;
        case 'dataset':
          type = 'Dataset';
          break;
        default:
          type = data.form_data_id ? 'Data Manager' : '';
      }
      return type;
    },

    sourceUi(data) {
      let source = '';
      switch (data.type) {
        case 'form':
          source = data.form_data_name;
          break;
        case 'dataset':
          source = data.data_source.dataset ? data.data_source.dataset.dataset_name : '';
          break;
        default:
          source = '';
      }
      return source;
    },

    selectMode(val) {
      this.typeMode = val;
    },

    selectTab(data) {
      this.tabSelected = data;
      this.selected_rows = [];
    },

    loading(data) {
      const { pagination } = data;
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      if (this.select_type && this.filter_data) {
        dataFilter[this.select_type] = this.filter_data;
      }
      // pagination.query_type = this.select_type;
      pagination.filter = JSON.stringify(dataFilter);
      // pagination.sort = JSON.stringify({ updated_at: -1 });
      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },
    filter(val) {
      this.$refs.formUiTableComponent.setFilter(val);
      this.popoverSearchShow = false;
    },

    loadingMulti(data) {
      const { pagination } = data;
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      if (this.select_type_multi && this.filter_data_multi) {
        dataFilter[this.select_type_multi] = this.filter_data_multi;
      }
      // pagination.query_type = this.select_type;
      pagination.filter = JSON.stringify(dataFilter);
      // pagination.sort = JSON.stringify({ updated_at: -1 });
      if (this.load_first) {
        this.showLoading();
      }
    },
    loadedMulti(data) {
      this.data_table_multi = data.data.data;
      if (this.load_first_multi) {
        this.hideLoading();
      } else {
        this.load_first_multi = !this.load_first_multi;
      }
    },
    filterMulti(val) {
      this.$refs.multiFormUiTableComponent.setFilter(val);
      this.popoverSearchMultiShow = false;
    },

    openDetail(id) {
      // const jxmVersion = localStorage.getItem('jxm_version');
      // const routeDestination = !jxmVersion || jxmVersion === 'v1' ? 'form-ui' : 'experience-manager';
      this.$router.push(`/experience-manager/update/${id}`);
    },
    openModalCreate() {
      this.isOpen = true;
      this.$refs.modalForm.show();
    },
    closeModalCreate() {
      this.$refs.modalForm.hide();
      this.isOpen = false;
    },

    openDetailMulti(id) {
      // const jxmVersion = localStorage.getItem('jxm_version');
      // const routeDestination = !jxmVersion || jxmVersion === 'v1' ? 'multiple-form-ui' : 'multiple-experience-manager';
      this.$router.push(`/multiple-experience-manager/update/${id}`);
    },
    openModalCreateMulti() {
      this.isOpenMulti = true;
      this.$refs.modalFormMulti.show();
    },
    closeModalCreateMulti() {
      this.$refs.modalFormMulti.hide();
      this.isOpenMulti = false;
    },

    openModalCreateNew() {
      this.$refs.appTypeFormDataModal.show();
    },

    nextStep() {
      if (this.typeMode === 'blank') {
        if (this.tabSelected === 'single') {
          this.isOpen = true;
          this.$refs.modalForm.show();
        } else {
          this.isOpenMulti = true;
          this.$refs.modalFormMulti.show();
        }
      } else {
        this.$refs.appCodeFormDataModal.show();
        setTimeout(() => { this.showEditor = true; }, 500);
      }
    },

    closeTypeForm() {
      this.$refs.appTypeFormDataModal.hide();
    },

    createCodeData() {
      const json = typeof this.$refs.jsonEditor !== 'undefined' ? this.$refs.jsonEditor.getData().trim() : '';
      if (json) {
        const param = JSON.parse(json);
        if (this.tabSelected === 'single') {
          this.createForm(param).then((response) => {
            if (!response.error) {
              this.jsonData = '';
              this.showEditor = false;
              this.$refs.appCodeFormDataModal.hide();
              this.$router.push(`/experience-manager/update/${response.data.id}`);
            } else {
              // eslint-disable-next-line
              console.log('gagal');
              this.$store.commit('jStoreNotificationScreen/toggleProblem', response.message);
            }
          });
        } else {
          this.createMultiForm(param).then((response) => {
            if (!response.error) {
              this.jsonData = '';
              this.showEditor = false;
              this.$refs.appCodeFormDataModal.hide();
              this.$router.push(`/multiple-experience-manager/update/${response.data.id}`);
            } else {
              // eslint-disable-next-line
              console.log('gagal');
              this.$store.commit('jStoreNotificationScreen/toggleProblem', response.message);
            }
          });
        }
      }
    },

    closeCodeForm() {
      this.jsonData = '';
      this.showEditor = false;
      this.$refs.appCodeFormDataModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager/jFormUiList.vue